import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "invincify_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminAxios = axios.create({
  baseURL: API,
  withCredentials: true,
});

adminAxios.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const login = async (email, password) => {
  const res = await adminAxios.post("/admin/login", { email, password });
  setToken(res.data.access_token);
  return res.data.user;
};

export const logout = async () => {
  try {
    await adminAxios.post("/admin/logout");
  } catch (_) {
    // ignore logout failure
  }
  clearToken();
};

export const me = async () => {
  const res = await adminAxios.get("/admin/me");
  return res.data;
};

export const updateSiteContent = async (patch) => {
  const res = await adminAxios.put("/admin/site-content", patch);
  return res.data;
};

export const listBookings = async () => {
  const res = await adminAxios.get("/admin/bookings");
  return res.data;
};

export const deleteBooking = async (id) => {
  await adminAxios.delete(`/admin/bookings/${id}`);
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const formatErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
